export const ONLINE_M = 'online-m';
export const ONLINE_Y = 'online-y';
export const BUSINESS_M = 'business-m';
export const BUSINESS_Y = 'business-y';
export const ENTERPRISE_M = 'enterprise-m';
export const ENTERPRISE_Y = 'enterprise-y';
